import styled from 'styled-components';
import { getSemanticValue, Spaces } from '@freenow/wave';
export const Header = styled.div `
    height: 128px;
    margin-bottom: ${Spaces[2]};

    user-select: none;

    background-color: ${getSemanticValue('background-element-disabled-faded')};

    color: ${getSemanticValue('foreground-neutral-faded')};
    font-size: 144px;
    font-weight: 700;
    text-align: center;
    line-height: 128px;
`;
